import {toInteger} from "lodash";

export default {
    methods: {
        isUnlimit(value) {
            return value === toInteger(process.env.INT32)
        }
    }
}
